<!--
  ~ Copyright (c) 2022.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="overlay"></div>

<div class="row login-content">

  <!-- TODO START remove me when transfer to Secanim is finished  -->
  <app-provalt-banner-collectable></app-provalt-banner-collectable>
  <!-- TODO End remove me when transfer to Secanim is finished  -->

  <div class="bg-white col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">

    <!-- TODO START uncomment me when transfer to Secanim is finished  -->
    <!--    <div class="text-center">-->
    <!--      <span class="auth-head-icon"><em class="la la-user"></em></span>-->
    <!--    </div>-->
    <!-- TODO END uncomment me when transfer to Secanim is finished  -->

    <div class="ibox">
      <div class="ibox-head justify-content-center">
        <div class="ibox-title text-uppercase text-center" i18n="@@login">Login</div>
      </div>

      <div class="ibox-body">
        <form [formGroup]="loginFG" #loginForm="ngForm" (ngSubmit)="loginFormSubmit()">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2">
            <app-input-username controlName="username" [formGroup]="loginFG"  [showRequired]="false"
                                [submitted]="loginForm?.submitted"></app-input-username>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2">
            <app-input-password controlName="password" [formGroup]="loginFG" [showRequired]="false"
                                [submitted]="loginForm?.submitted" ></app-input-password>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4 mb-4 text-right">
            <a class="text-primary text-right" routerLink="/forgot-password">
              <span i18n="@@forgotPassword">Forgot password</span> ?
            </a>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4">
            <button type="submit" class="btn btn-success btn-block btn-rounded text-uppercase" i18n="@@login">
              Login
            </button>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-danger text-justify mb-2">
            <br>
            <p i18n="@@loginHelp">
              For every missed password or password not accepted, be king to clic on "Forget password" link and follow on screen instructions
            </p>
          </div>

        </form>
      </div>
    </div>
  </div>

  <div
    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-inline-flex align-items-center py-4 px-5 bg-success-700">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
        <app-display-logos-provalt [oneLine]="true"></app-display-logos-provalt>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify text-white mb-1">
        <h3 i18n="@@removeCorpse" class="mb-4 mt-2">Request an animal corpse pickup</h3>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify text-white mb-2">
        <p i18n="@@loginIntro">
          You are in the A.T.M. removal request application.You can also edit removal slips and rendering output logs.
          If you do not know your password and / or username yet: Contact us.
        </p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify text-white mb-2">
        <app-display-contact [oneLine]="false"></app-display-contact>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
        <app-display-logos-available [oneLine]="true"></app-display-logos-available>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 bg-dark pt-1 pb-1">
    <div class="row">
      <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
        <a class="text-white" routerLink="/help" target="_blank">
          <span i18n="@@help">Help</span>
        </a>
      </div>

      <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
        <a class="text-white" routerLink="/cgv" target="_blank">
          <span i18n="@@cgv">CGV</span>
        </a>
      </div>

      <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
        <a class="text-white" routerLink="/cgu" target="_blank">
          <span i18n="@@cgu">CGU</span>
        </a>
      </div>

      <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
        <a class="text-white" routerLink="/privacy" target="_blank">
          <span i18n="@@privacyPolicies">Privacy policies</span>
        </a>
      </div>
    </div>
  </div>
</div>
